import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { compose } from 'recompose';
import { Card, Table, Image } from 'semantic-ui-react';
import PlainHeader from '../../components/plain-header';

import axios from 'axios';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasOrgansation from '../../hocs/has-organisation';


class Profiles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profiles: null,
      isLoading: true,
    };
    console.log('Profiles constructor');
  }

  componentDidMount = async () => {
    const AX = axios.create({
      baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production',
      timeout: 10000,
    });

    const response = await AX.get('/profiles/corq').then(r => r.data);

    const { data, meta } = response;

    console.log(meta);

    const profiles = data;
    this.setState({
      profiles,
      meta,
      isLoading: false,
    });
  }

  render() {
    const { isLoading, profiles, meta } = this.state;
    return (
      <div>

        <div className="page">
          <div className="padded-content white border-bottom">
            <PlainHeader title="PROFILE QA SYSTEM" />
          </div>
          <div className="page-content">
            { isLoading &&
            <h1>LOADING....</h1>
            }
            {!isLoading &&

              <Table celled padded>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell singleLine>Profile Pic</Table.HeaderCell>
                    <Table.HeaderCell singleLine>Name</Table.HeaderCell>
                    <Table.HeaderCell>Instagram</Table.HeaderCell>
                    <Table.HeaderCell>Instagram OK?</Table.HeaderCell>
                    <Table.HeaderCell>Tiktok</Table.HeaderCell>
                    <Table.HeaderCell>Tiktok OK?</Table.HeaderCell>
                    <Table.HeaderCell>Twitter</Table.HeaderCell>
                    <Table.HeaderCell>CreatedDate</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>


                <Table.Body>
                  {
                    _.map(profiles, profile => (
                      <Table.Row>
                        <Table.Cell singleLine><Image src={profile.instagramThumbnail} /></Table.Cell>
                        <Table.Cell singleLine>
                          <h3>{profile.name}</h3>
                        </Table.Cell>
                        <Table.Cell>
                          <h4>{profile.instagram}</h4>
                          {profile.instagramFollowers}
                        </Table.Cell>
                        <Table.Cell>{profile.instagramOk ? 'yes' : 'no'}</Table.Cell>
                        <Table.Cell>
                          <h4>{profile.tiktok}</h4>
                          {profile.tiktokCount}
                        </Table.Cell>
                        <Table.Cell>{profile.tiktokOk ? 'yes' : 'no'}</Table.Cell>
                        <Table.Cell>{profile.twitter}</Table.Cell>
                        <Table.Cell>{profile.createdDate}</Table.Cell>


                      </Table.Row>
                    ))
                  }


                </Table.Body>
              </Table>

            }


          </div>
        </div>


      </div>
    );
  }
}

Profiles.propTypes = {
  // campaignId: PropTypes.string.isRequired,
  // organisation: PropTypes.object.isRequired,
};


export default compose(
  hasOrgansation,
  hasJSONAPIClient,
)(Profiles);



/** WEBPACK FOOTER **
 ** ./src/containers/profiles/index.js
 **/